import { scaleBand, scaleLinear } from 'd3-scale';

export function barChartScale({ getConfiguration, meta, data, width, height }) {
  let labels, numbers;

  const vertical = getConfiguration('orientation') === 'vertical';
  const barLabels = data.map(bar => bar.row_label);

  const padding = 1 - getConfiguration('barSize') / 100;

  labels = scaleBand()
    .domain(barLabels)
    .rangeRound([0, vertical ? width : height])
    .padding(padding);
  labels.hasTextLabels = true;

  let barValues = data.map(bar =>
    Object.values(bar).filter(val => typeof val === 'number')
  );

  if (getConfiguration('groupMode') === 'stacked') {
    barValues = barValues.map(bar => bar.reduce((sum, v) => sum + v, 0));
  } else {
    barValues = barValues.flat();
  }

  const minValue = getConfiguration('minValue', Math.min(0, ...barValues));
  const maxValue = getConfiguration('maxValue', Math.max(...barValues));

  numbers = scaleLinear()
    .rangeRound(vertical ? [height, 0] : [0, width])
    .domain([minValue, maxValue]);

  return {
    x: vertical ? labels : numbers,
    y: vertical ? numbers : labels,
  };
}
